import script from "./DonationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationCard.vue?vue&type=script&setup=true&lang=ts"

import "./DonationCard.vue?vue&type=style&index=0&id=39ccf776&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ccf776"]])

export default __exports__